import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Modal } from '@wfp/ui';

import { useCurrentEdition } from '../../hooks/home';
import { HighlightsTitle, type Section, Topic } from '../../restapi/types';
import { allSectionsToOrder } from '../../restapi/document';
import { DraggableCard } from '../common/DraggableCard';

import './OrderModal.scss';


interface Props {
	done: (data?: Section[]) => void,
}

export function OrderModal(props: Props) {
	const ed = useCurrentEdition();
	const [sections, setSections] = useState<Section[]>(allSectionsToOrder(ed!));

	const moveCard = (dragIndex: number, hoverIndex: number) => {
		const s = sections[dragIndex];
		const updatedSections = [...sections];
		updatedSections.splice(dragIndex, 1);  // remove it
		updatedSections.splice(hoverIndex, 0, s);  // add t back
		setSections(updatedSections);
	};

	return (
		<Modal
			open
			modalHeading="Order sections"
			primaryButtonText="Confirm"
			secondaryButtonText="Cancel"
			onRequestSubmit={() =>  // primary button close
				props.done(sections)
			}
			onRequestClose={() => props.done()}>

			<p>Drag and drop titles to reorder the sections</p>

			<DndProvider backend={HTML5Backend}>
				{sections.map((s, i) =>
					<DraggableCard key={s.id} id={s.id} index={i}
								   className="section-in-order"
								   moveCard={moveCard}>
						{s.topic} - {s.topic === Topic.highlights ? HighlightsTitle : s.title}
					</DraggableCard>)}
			</DndProvider>

		</Modal>
	);
}